import { TextViewDraftJSSEO } from 'src/components/sections/campaign/common/TextViewDraftJS'
import DOMPurify from 'dompurify'
import './contentSEO.scss'
import { useState, useEffect } from 'react'

type Props = {
  dataCMS: any
  sectionClassname?: string
}

export function ContentSEO({
  dataCMS,
  sectionClassname = '',
}: Readonly<Props>) {
  const [contentSeo, setContentSeo] = useState<string | null>(null)
  const defaultClassnames = sectionClassname || 'section-SEO mt-16'

  useEffect(() => {
    const data = dataCMS.sections.filter(
      (item: {
        name: string
        data: { configuration: string; contentSEO: string }
      }) => {
        if (item.name === '[Coleção] Texto SEO' && item.data.contentSEO) {
          return true
        }

        return (
          item.name === '5.6 Texto SEO [WEB]' &&
          (item.data.configuration === 'exibir website e aplicativo' ||
            item.data.configuration === 'exibir apenas website')
        )
      }
    )

    if (data.length) {
      const sanitizedContentSEO =
        typeof DOMPurify.sanitize === 'function'
          ? DOMPurify.sanitize(data[0].data.contentSEO)
          : data[0].data.contentSEO

      setContentSeo(sanitizedContentSEO as string)
    } else {
      setContentSeo(null)
    }
  }, [contentSeo, dataCMS.sections])

  return (
    <>
      {contentSeo && (
        <div className={defaultClassnames}>
          <TextViewDraftJSSEO text={contentSeo} />
        </div>
      )}
    </>
  )
}
